import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';
import { ConfigurationServices } from '../../../configuration/services';

/**
 * Generated class for the DeliveryTakeawaySalesAvgPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delivery-takeaway-sales-avg',
  templateUrl: 'delivery-takeaway-sales-avg.html',
})
export class DeliveryTakeawaySalesAvgPage {
  chartData: any;
  chartLabels: any;
  chartCheck: any;
  sales_delivery_avg = 0;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'date', name: this.translate.instant('general-fecha') },
    { prop: 'ticket_number', name: this.translate.instant('general-n-ticket') },
    { prop: 'delivery', name: this.translate.instant('general-delivery') },
    { prop: 'total', name: this.translate.instant('general-total') + " (" + this.globals.currency_symbol + ")" },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
    public configurationServices: ConfigurationServices) {
    this.getAnalyticsData();
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {
    //reset
    this.sales_delivery_avg = 0;
    this.chartCheck = false;

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);


    this.http.post(this.globals.analytics_path + 'analytics/delivery_average', params, {})
      .subscribe(async response => {
        //chart
        this.chartData = response['data_delivery']['data'];
        this.chartLabels = response['data_delivery']['labels'];
        //
        this.sales_delivery_avg = response['sales_avg'];
        //list
        this.rows = response['list'];
        this.temp = response['list'];
        this.chartCheck = true;
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

}



// WEBPACK FOOTER //
// ./src/pages/analytics/reports/delivery-takeaway-sales-avg/delivery-takeaway-sales-avg.ts